<template>
  <v-toolbar
    tag="div"
    dense
    color="transparent"
    elevation="0"
    align-with-title
    light
  >
    <v-breadcrumbs :items="filteredBreadcrumbs" class="crumbs py-3 px-0" />
  </v-toolbar>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AppBreadcrumbs',
  data() {
    return {}
  },
  computed: {
    filteredBreadcrumbs() {
      return this.breadcrumbs.filter((item) => {
        if (item.text !== 'undefined') {
          return item ?? ''
        }
      })
    },
    breadcrumbs() {
      const { matched } = this.$route
      return matched.map((route, index) => {
        let to =
          index === matched.length - 1
            ? this.$route.path
            : route.path || route.redirect
        let text = this.$vuetify.lang.t('' + route.meta.title)
        to = this.checkVariables(to)
        text = this.checkVariables(text)
        return {
          text: this.$t(text),
          to: to,
          exact: false,
          disabled: false,
        }
      })
    },
  },
  methods: {
    checkVariables(text) {
      if (typeof text !== 'string') {
        return text
      }
      return text === 'null' ? '' : text
    },
  },
  created() {},
}
</script>

<style lang="scss">
.crumbs {
  font-family: 'Open Sans';
  font-weight: normal;
  li {
    font-size: 12px !important;
  }
}
</style>
